import {useEffect} from "react";
import {route, UrlBaseTypes} from "carrier-fe";

function Root() {
    /*
     * Redirect to the main login page
     */
    useEffect(() => {
        window.location.href = route('/dashboard', undefined, UrlBaseTypes.ADMIN);
    }, []);

    return null;
}

export default Root;
